import { Checkbox } from 'antd'
import PropTypes from 'prop-types'
import { Text } from '@qonsoll/react-design'
import { useGetNewspapers } from 'domains/Newspaper/hooks'
import { useSubfilterActions } from 'hooks'
import { useTranslations } from 'contexts/Translation'

const NewspaperFilter = ({ filterData, setFilterData }) => {
  const [newspapers] = useGetNewspapers()
  const { t } = useTranslations()

  const { onToggleDetails, onChange, checkIsEnabled } = useSubfilterActions({
    filterData,
    setFilterData,
    fieldName: 'newspaperId',
    operand: '==',
    type: 'newspaper'
  })

  return (
    <details
      open={localStorage.getItem(`newspaper-details-visibility`) === 'opened'}>
      <summary onClick={onToggleDetails}>{t('Newspaper')}</summary>
      {newspapers?.map((newspaper, index) => (
        <Checkbox
          key={`status-${index}`}
          checked={checkIsEnabled(newspaper)}
          onChange={() => onChange(newspaper)}>
          <Text wordBreak="break-all">
            {newspaper?.name || t('Unnamed filter')}
          </Text>
        </Checkbox>
      ))}
    </details>
  )
}

NewspaperFilter.propTypes = {
  filterData: PropTypes.object,
  setFilterData: PropTypes.func
}

export default NewspaperFilter
